/**
 * Copyright 2025 IBM Corp.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { setTimeout } from "node:timers/promises";
import { ZodType } from "zod";

export async function* sleep(ms: number, signal?: AbortSignal) {
  const start = Date.now();
  const ctx = { iteration: 0, elapsed: 0 };
  while (true) {
    await setTimeout(ms, {
      signal,
    });
    ctx.elapsed = Date.now() - start;
    ctx.iteration++;
    yield ctx;
  }
}

export function validate<T>(value: unknown, schema: ZodType<T>): asserts value is T {
  schema.parse(value);
}
